export default __webpack_public_path__ + "static/media/affiliate-commission-mobile-banner.fbe8abac.webp";